<template>
  <div class="add-lection">
    <a-spin :spinning="bigLoading">
      <a-form>
        <a-form-item
            label="典籍名稱"
            :label-col="{ span: 5 }"
            :wrapper-col="{ span: 12 }"
            required
        >
          <a-input placeholder="請輸入經文名稱" v-model="para.name"></a-input>
        </a-form-item>
        <a-form-item
            label="典籍簡稱"
            :label-col="{ span: 5 }"
            :wrapper-col="{ span: 12 }"
            required
        >
          <a-input placeholder="典籍簡稱(不超過五字)" :max-length="5" v-model="para.otherName"></a-input>
        </a-form-item>
        <a-form-item
            label="作者"
            :label-col="{ span: 5 }"
            :wrapper-col="{ span: 12 }"
            required
        >
          <a-input placeholder="作者(不超過五字)" :max-length="5" v-model="para.author"></a-input>
        </a-form-item>
        <a-form-item
            label="成書年代"
            :label-col="{ span: 5 }"
            :wrapper-col="{ span: 12 }"
            required
        >
          <a-input placeholder="成書年代" :max-length="15" v-model="para.scriptureAge"></a-input>
        </a-form-item>
        <a-form-item
            label="典籍來源"
            :label-col="{ span: 5 }"
            :wrapper-col="{ span: 12 }"
            required
        >
          <a-input placeholder="典籍來源" :max-length="15" v-model="para.scriptureSource"></a-input>
        </a-form-item>
        <a-form-item
            label="典籍簡介"
            :label-col="{ span: 5 }"
            :wrapper-col="{ span: 12 }"
            required
        >
          <a-input type="textarea" autoSize placeholder="典籍簡介" v-model="para.desc"></a-input>
        </a-form-item>
        <a-form-item
            label="權限設置"
            :label-col="{ span: 5 }"
            :wrapper-col="{ span: 12 }"
            required
        >
          <p style="color:#ff3657;font-size: 14px;">請設置每類用戶角色的典籍可閱百分比，最大為100，最小為0</p>
          <div class="vip-item">
            <span class="title">非會員：</span>
            <div v-for="(item,index) in noVipList" :key="index">
              <a-input :min="0" :max="100" type="number" :addon-before="item.userDesc" addon-after="%"
                       v-model="item.radio" style="width:200px;"/>
            </div>
          </div>
          <div class="vip-item">
            <span class="title">會員：</span>
            <div v-for="(item,index) in vipList" :key="index">
              <a-input :min="0" :max="100" type="number" :addon-before="item.vipDesc" addon-after="%"
                       v-model="item.radio" style="width:200px;"/>
            </div>
          </div>
        </a-form-item>
        <a-form-item
            label="典籍分類"
            :label-col="{ span: 5 }"
            :wrapper-col="{ span: 12 }"
            required
        >
          一級分類：
          <a-select v-model="oneCla" placeholder="選擇一級分類" style="width:140px;" @change="oneChange">
            <a-select-option v-for="item in oneList" :key="item.id" :value="item.id">{{ item.desc }}
            </a-select-option>
          </a-select>
          二級分類：
          <a-select v-model="para.type" placeholder="選擇二級分類" style="width:140px;">
            <a-select-option v-for="item in typeList" :key="item.id" :value="item.id">{{ item.desc }}
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item
            label="典籍内容分類"
            :label-col="{ span: 5 }"
            :wrapper-col="{ span: 12 }"
            required
        >
          <a-radio-group name="radioGroup" v-model="lectionType">
            <a-radio :value="1">上傳PDF</a-radio>
            <a-radio :value="2">上傳圖片</a-radio>
            <a-radio :value="3">上傳富文本</a-radio>
          </a-radio-group>
        </a-form-item>
        <a-form-item
            label="典籍內容"
            :label-col="{ span: 5 }"
            :wrapper-col="{ span: 12 }"
            required
            style="text-align: left"
        >
          <div v-if="lectionType!==3">
            <div style="margin-bottom:20px;" v-if="imgList.length">
              <a-button @click="clearImg">清理图片</a-button>
            </div>
            <vuedraggable class="wrapper" v-model="imgList" animation="300">
              <transition-group>
                <div v-for="(item,index) in imgList" :key="item.id" class="item">
                  <img :src="item.path" alt="" class="big" @click="showBig(item.path)">
                  <img src="../../assets/image/close.png" alt="" class="del" @click="delImg(index)">
                </div>
              </transition-group>
            </vuedraggable>
            <a-upload
                v-if="lectionType === 1"
                :withCredentials="true"
                :showUploadList="false"
                :disabled="upLoading"
                :customRequest="upPdf"
            >
              <div
                  style="margin-bottom:20px;width:100px;text-align:center;height: 100px;border:1px solid #f1f1f1;border-radius: 4px;cursor:pointer;">
                <a-icon :type="upLoading?'loading':'plus'" style="margin-top:30px;"/>
                <div class="ant-upload-text">{{ upMsg }}</div>
              </div>
            </a-upload>
            <a-upload
                v-if="lectionType === 2"
                :withCredentials="true"
                accept="image/*"
                multiple
                :showUploadList="false"
                :disabled="upLoading"
                :customRequest="upPic"
            >
              <div
                  style="margin-bottom:20px;width:100px;text-align:center;height: 100px;border:1px solid #f1f1f1;border-radius: 4px;cursor:pointer;">
                <a-icon :type="upLoading?'loading':'plus'" style="margin-top:30px;"/>
                <div class="ant-upload-text">選擇文件</div>
              </div>
            </a-upload>
          </div>
          <div v-show="lectionType===3">
            <div id="editor"></div>
            <a-button class="clear-or" @click="addOne">添加内容至列表</a-button>
            <a-button class="clear-or" @click="delAll">清空列表</a-button>
            <swiper class="swiper-container-box" ref="mySwiper" :options="swiperOptions">
              <swiper-slide v-for="(item,index) in detailList" :key="index">
                <a-button class="edit-one" size="small" @click="edit(item,index)" type="primary">编辑
                </a-button>
                <a-button class="del-one" size="small" @click="del(item,index)" type="primary">删除</a-button>
                <div class="html-box" v-html="item"></div>
              </swiper-slide>
            </swiper>
          </div>
        </a-form-item>
      </a-form>
      <a-button style="width:500px;margin:40px 0;" :loading="subLoading" class="sub" type="primary" @click="sub">
        上傳内容並提交
      </a-button>
    </a-spin>
    <a-modal
        title=""
        :visible="bigImgShow"
        :footer="null"
        :maskClosable="true"
        :mask="true"
        :keyboard="true"
        :width="1080"
        @cancel="hideBigImg"
        :closable="false"
    >
      <img style="max-width:1000px;display: block;margin:0 auto;" :src="bigImg" alt="">
    </a-modal>
  </div>
</template>
<script>
import vuedraggable from 'vuedraggable';
import {Swiper, SwiperSlide, directive} from 'vue-awesome-swiper'

export default {
  components: {
    vuedraggable,
    Swiper,
    SwiperSlide
  },
  directives: {
    swiper: directive
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.$swiper
    },
  },
  data() {
    return {
      oneCla:undefined,
      bigLoading: false,
      editIndex: 0,
      editDetail: false,
      swiperOptions: {
        pagination: {
          el: '.swiper-pagination'
        },
        // Some Swiper option/callback...
      },
      detailList: [],
      editorOption: {
        modules: {
          toolbar: '#toolbar'
        },
        placeholder: '請在此處編輯叢書詳情'
      },
      detail: '',
      lectionType: 1,
      subLoading: false,
      previewVisible: false,
      previewImage: '',
      fileList: [],
      typeList: [],
      para: {
        name: undefined,
        type: undefined,
        desc: undefined,
        otherName: undefined,
        author: undefined,
        scriptureSource: undefined,
        scriptureAge: undefined
      },
      imgList: [],
      upLoading: false,
      bigImg: '',
      bigImgShow: false,
      upMsg: '選擇PDF文件',
      noVipList: [
        {radio: 0, userType: 1, userDesc: '遊客'},
        {radio: 0, userType: 2, userDesc: '註冊用戶'},
      ],
      vipList: [],
      editor: null,
      oneList:[]
    }
  },
  methods: {
    getOneClaList(){
      this.$http({
        method: 'get',
        url: '/manager/category/selectAll',
      }).then(res=>{
        this.oneList = res.data;
      })
    },
    oneChange(val){
      this.para.type = undefined;
      this.getClaList()
    },
    getVip() {
      let self = this;
      this.loading = true;
      return new Promise((resolve, reject) => {
        self.$http({
          method: 'post',
          url: '/manager/vip/list',
        }).then(function (res) {
          self.loading = false;
          let arr = []
          res.data.forEach(item => {
            arr.push({
              radio: 0,
              vipDesc: item.vipDesc,
              vipType: item.vipType
            })
          })
          arr.sort((a, b) => {
            return a.vipType - b.vipType;
          })
          self.vipList = arr;
          resolve()
        }).catch(err => {
          self.loading = false;
          self.$Message.error(JSON.stringify(err))
          resolve();
        })
      })
    },
    delAll() {
      this.detailList.splice(0, this.detailList.length)
    },
    del(item, index) {
      this.detailList.splice(index, 1)
    },
    edit(item, index) {
      this.editIndex = index;
      this.editDetail = true;
      this.editor.txt.html(item)
    },
    addOne() {
      let self = this;
      console.log(this.detailList[this.editIndex])
      if (this.editDetail) {
        // this.detailList[this.editIndex] = this.editor.txt.html();
        this.$set(this.detailList, this.editIndex, this.editor.txt.html())
        this.editDetail = false;
      } else {
        this.detailList.push(this.editor.txt.html())
        setTimeout(function () {
          self.swiper.slideTo(self.detailList.length - 1, 400, false)
        }, 200)
      }
      this.editor.txt.clear()
    },
    clearImg() {
      this.imgList.splice(0, this.imgList.length)
    },
    upPicDetail(file, fn) {
      let self = this;
      this.$load.show();
      let param = new FormData()
      param.append('files', file[0])
      let config = {
        headers: {'Content-Type': 'multipart/form-data'}
      };
      this.$http.post('/manager/media/upload/pic', param, config)
          .then(response => {
            fn(response.data.mediaInfo[0].path)
            self.$load.hide();
          })
    },
    delImg(index) {
      this.imgList.splice(index, 1)
    },
    upPic(file) {
      let self = this;
      this.upLoading = true;
      let param = new FormData()
      param.append('files', file.file)
      let config = {
        headers: {'Content-Type': 'multipart/form-data'}
      };
      this.$http.post('/manager/media/upload/pic?isSy=1', param, config)
          .then(response => {
            self.imgList = self.imgList.concat(response.data.mediaInfo)
            self.upLoading = false;
          })
    },
    upPdf(file) {
      let self = this;
      this.upLoading = true;
      let upTime = new Date().getTime();
      let param = new FormData()
      param.append('files', file.file)
      param.append('randNumber', upTime)
      console.log(upTime)
      let config = {
        headers: {'Content-Type': 'multipart/form-data'},
        onUploadProgress: function (progressEvent) { //原生获取上传进度的事件
          if (progressEvent.lengthComputable) {
            let complete = (progressEvent.loaded / progressEvent.total * 100 | 0) + '%'
            self.upMsg = '上傳 ' + complete
            if (complete === '100%') {
              self.upMsg = '上傳完成，处理中'
              // let progress = setInterval(function () {
              //   self.$http.post('/manager/media/upload/pdf/index?randNumber=' + upTime)
              //       .then(response => {
              //         self.upMsg = '正在处理第' + response.data.currentPage + '/' + response.data.totalPages + '张'
              //         if (response.data.currentPage === response.data.totalPages) {
              //           clearInterval(progress)
              //           self.upMsg = '選擇PDF文件'
              //         }
              //       }).catch(err => {
              //   })
              // }, 1000)
            }
          }
        },
      };
      this.$http.post('/manager/media/upload/pdf', param, config)
          .then(response => {
            self.imgList = self.imgList.concat(response.data.mediaInfo)
            self.upLoading = false;
            self.upMsg = '選擇PDF文件'
          }).catch(err => {
        self.upLoading = false;
        self.upMsg = '選擇PDF文件'
      })
    },
    getClaList() {
      let self = this;
      return new Promise((resolve, reject) => {
        self.$http({
          method: 'get',
          url: '/manager/type/scripture/list?id=' + this.oneCla,
        }).then(function (res) {
          if (res.data && res.data.length) {
            self.typeList = res.data;
          } else {
            self.typeList = []
          }
          resolve()
        }).catch(err => {
          reject();
        })
      })

    },
    sub() {
      let self = this;
      let flag = false;
      if (this.para.name === '' || !this.para.name) {
        this.$Message.warning('典籍名稱不能為空')
        return false;
      }
      if (this.para.otherName === '' || !this.para.otherName) {
        this.$Message.warning('典籍簡稱不能為空')
        return false;
      }
      if (this.para.author === '' || !this.para.author) {
        this.$Message.warning('典籍作者不能為空')
        return false;
      }
      if (this.para.scriptureAge === '' || !this.para.scriptureAge) {
        this.$Message.warning('成書年代不能為空')
        return false;
      }
      if (this.para.scriptureSource === '' || !this.para.scriptureSource) {
        this.$Message.warning('典籍來源不能為空')
        return false;
      }
      if (this.para.desc === '' || !this.para.desc) {
        this.$Message.warning('典籍簡介不能為空')
        return false;
      }
      if (!this.para.type) {
        this.$Message.warning('典籍分類不能為空')
        return false;
      }
      this.noVipList.forEach(item => {
        if (!item.radio || item.radio === '') {
          this.$Message.warning(`${item.userDesc}百分比不能為空`);
          flag = true;
        }
        if (item.radio * 1 > 100) {
          this.$Message.warning(`${item.userDesc}的可觀看百分比不能超出100%`);
          flag = true;
        }
        if (item.radio * 1 < 0) {
          this.$Message.warning(`${item.userDesc}的可觀看百分比不能小於0`);
          flag = true;
        }
      })
      this.vipList.forEach(item => {
        if (!item.radio || item.radio === '') {
          this.$Message.warning(`${item.vipDesc}百分比不能為空`);
          flag = true;
        }
        if (item.radio * 1 > 100) {
          this.$Message.warning(`${item.vipDesc}的可觀看百分比不能超出100%`);
          flag = true;
        }
        if (item.radio * 1 < 0) {
          this.$Message.warning(`${item.vipDesc}的可觀看百分比不能小於0`);
          flag = true;
        }
      })
      if (flag) {
        return false;
      }
      let detailFlag = false;
      if (this.lectionType === 1) {
        if (this.imgList.length === 0) {
          this.$Message.warning('請上傳典籍PDF')
          detailFlag = true;
        }
      } else if (this.lectionType === 2) {
        if (this.imgList.length === 0) {
          this.$Message.warning('請上傳典籍圖片')
          detailFlag = true;
        }
      } else if (this.lectionType === 3) {
        if (!this.detailList.length) {
          this.$Message.warning('請添加经书内容')
          detailFlag = true;
        }
      }
      if (detailFlag) {
        return false;
      }
      let data = {}
      let url;
      data.title = this.para.name;
      data.abbreviation = this.para.otherName;
      data.author = this.para.author;
      data.scriptureSource = this.para.scriptureSource;
      data.scriptureAge = this.para.scriptureAge
      data.introduction = this.para.desc;
      data.scriptureTypeId = this.para.type;
      let arr = []
      this.imgList.forEach((item, index) => {
        arr.push({id: item.id, sortNum: (index * 1) + 1})
      })
      data.lectionType = this.lectionType;
      data.limits = []
      this.noVipList.forEach(item => {
        data.limits.push({
          radio: item.radio,
          userType: item.userType
        })
      })
      let obj = {
        userType: 3,
        vip: []
      }
      this.vipList.forEach(item => {
        obj.vip.push({
          radio: item.radio,
          vipType: item.vipType
        })
      })
      data.limits.push(obj)
      if (this.lectionType === 3) {
        data.lectionDesc = this.detailList;
      } else {
        data.picInfos = arr;
      }
      console.log(data)
      if (this.$route.query.id) {
        url = '/manager/scripture/update'
        data.id = this.$route.query.id;
      } else {
        url = '/manager/scripture/add'
        delete data.id;
      }
      this.subLoading = true;
      this.$http({
        method: 'post',
        url: url,
        data: data
      }).then(function (res) {
        self.$Message.success('操作成功');
        self.$router.replace({name: 'lectionList'})
        self.imgList.splice(0, self.imgList.length)
        self.para.name = '';
        self.para.otherName = '';
        self.para.type = '';
        self.para.desc = '';
        self.subLoading = false;
      }).catch(err => {
        self.subLoading = false;
      })
    },
    async initData() {
      this.bigLoading = true;
      await this.getOneClaList()
      await this.getVip()
      if (this.$route.query.id) {
        await this.setData()
        this.getClaList()
      }
      this.bigLoading = false;
    },
    setData() {
      let self = this;
      this.$load.show()
      return new Promise((resolve,reject)=>{
        self.$http({
          method: 'get',
          url: '/manager/scripture/detail',
          params: {
            scriptureId: self.$route.query.id
          }
        }).then(function (res) {
          self.para.name = res.data.title;
          self.oneCla = res.data.firstCategory ? res.data.firstCategory*1 : undefined;
          self.para.otherName = res.data.abbreviation;
          self.para.author = res.data.author ? res.data.author : undefined;
          self.para.scriptureAge = res.data.scriptureAge ? res.data.scriptureAge : undefined;
          self.para.scriptureSource = res.data.scriptureSource ? res.data.scriptureSource : undefined;
          self.para.desc = res.data.introduction;
          self.para.type = res.data.scriptureTypeId;
          self.lectionType = res.data.lectionType * 1;
          if (res.data.lectionDesc && res.data.lectionDesc.length) {
            self.detailList = res.data.lectionDesc;
          } else {
            self.lectionType = 1
          }
          if (res.data.mediaPics && res.data.mediaPics.length) {
            res.data.mediaPics.forEach(item => {
              self.imgList.push({
                id: item.id,
                path: item.picPath
              })
            })
          }
          self.noVipList.forEach(item => {
            res.data.limits && res.data.limits.forEach(sub => {
              if (item.userType === sub.userType) {
                item.radio = sub.radio;
              }
            })
          })
          res.data.limits && res.data.limits.forEach(sub => {
            if (sub.userType === 3) {
              self.vipList = sub.vip;
            }
          })
          self.$load.hide()
          resolve()
        }).catch(err => {
          console.log(err)
          self.$load.hide()
          reject();
        })
      })
    },
    showBig(img) {
      this.bigImg = img;
      this.bigImgShow = true;
    },
    hideBigImg() {
      this.bigImgShow = false;
      this.bigImg = ''
    }
  },
  created() {
    this.$emit('breadcrumbChange', ['典籍管理', '添加典籍'])
  },
  mounted() {
    this.$nextTick(function () {
      let self = this;
      const E = window.wangEditor
      this.editor = new E('#editor')
      this.editor.config.pasteFilterStyle = false
      this.editor.config.withCredentials = true
      this.editor.config.excludeMenus = [
        'fontName'
      ]
      this.editor.config.colors = [
        "#000000","#ffffff","#eeece0","#1c487f","#4d80bf","#c24f4a","#8baa4a","#7b5ba1","#46acc8","#f9963b","#f44336"
      ]
      this.editor.config.customUploadImg = function (resultFiles, insertImgFn) {
        console.log(resultFiles)
        // resultFiles 是 input 中选中的文件列表
        self.upPicDetail(resultFiles, insertImgFn)
      }
      this.editor.create()
      this.initData();
    })
  },
  beforeDestroy() {
    this.editor.destroy()
    this.editor = null
  }
}
</script>
<style lang="less">
.ant-select-dropdown {
  z-index: 20000;
}

div.add-lection {
  .clear-or {
    margin-top: 20px;
    margin-right: 20px;

    span {
      font-size: 14px;
    }
  }

  .swiper-container-box {
    width: 375px;
    height: 667px;
    border-radius: 10px;
    border: 1px solid #ccc;
    box-shadow: 4px 4px 5px #f1f1f1;
    overflow-x: hidden;
    position: fixed;
    right: 20px;
    bottom: 100px;
    background-color: #fff;
    z-index: 20000;

    .edit-one {
      font-size: 12px;
      position: absolute;
      top: 10px;
      right: 10px;

      span {
        font-size: 12px;
      }
    }

    .del-one {
      font-size: 12px;
      position: absolute;
      top: 40px;
      right: 10px;

      span {
        font-size: 12px;
      }
    }

    .html-box {
      width: 100%;
      height: 100%;
      overflow-x: hidden;
      overflow-y: auto;
      padding: 20px;
    }
  }

  .ql-toolbar.ql-snow {
    border-bottom: none;
    padding-top: 14px;
    padding-bottom: 0;
  }

  .ql-snow .ql-editor img {
    display: inline-block;
  }

  .ql-snow .ql-picker.ql-size, .ql-snow .ql-picker.ql-header {
    border: 1px solid #f1f1f1;
    border-radius: 4px;
  }

  .ql-snow .ql-color-picker .ql-picker-label svg, .ql-snow .ql-icon-picker .ql-picker-label svg {
    right: 4px;
    top: -6px;
    position: relative;
  }

  .ql-snow .ql-picker.ql-header .ql-picker-label[data-label]:not([data-label=''])::before, .ql-snow .ql-picker.ql-font .ql-picker-label[data-label]:not([data-label=''])::before, .ql-snow .ql-picker.ql-size .ql-picker-label[data-label]:not([data-label=''])::before, .ql-snow .ql-picker.ql-header .ql-picker-item[data-label]:not([data-label=''])::before, .ql-snow .ql-picker.ql-font .ql-picker-item[data-label]:not([data-label=''])::before, .ql-snow .ql-picker.ql-size .ql-picker-item[data-label]:not([data-label=''])::before {
    content: attr(data-label);
    position: relative;
    top: -8px;
  }

  .quill-editor {
    height: 400px;
  }

  .item {
    width: 100px;
    height: 100px;
    position: relative;
    float: left;
    margin-right: 20px;
    margin-bottom: 20px;

    .big {
      width: 100%;
      height: 100%;
      border-radius: 4px;
      object-fit: cover;
      cursor: move;
    }

    .del {
      width: 20px;
      position: absolute;
      right: -10px;
      top: -10px;
      z-index: 1;
    }
  }

  div.ant-upload-list-item {
    width: 140px;
    margin-right: 10px;
    float: left;
  }

  .ant-upload {
    float: left;
  }

  .ant-upload-list {
    margin-top: 76px;
  }

  .sub {
    width: 100%;
  }

  .ant-form-item-control {
    text-align: left;
  }
}
</style>